import { useEffect, useState } from 'react';

// A hook to assist with intentionally delaying a component render.
export const useDelay = (delay: number): boolean => {
  const safeDelay = Math.max(0, delay);

  const [isReady, setIsReady] = useState<boolean>(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsReady(true);
    }, safeDelay);

    return () => clearTimeout(timer);
  }, [safeDelay]);

  return isReady;
};

export default useDelay;
